import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setCreateTaskError, setLoading, setTaskId } from "../../repository/slice";
import { getSingleCourse } from "../getSingleCourse/action";

function* createTaskWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, `/api/admin/courses/${payload.courseId}/add-content`, payload.body);
        if (isError) {
            yield put(setCreateTaskError(message));
        } else {
            yield put(setCreateTaskError(null));
            yield put(setTaskId(data.id));
            yield put(getSingleCourse({ id: Number(payload.courseId) }));
        }
    } catch (error) {
        console.error("createTaskWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* createTaskWatcher() {
    yield takeEvery("@saga/CREATE_TASK", createTaskWorker);
};
